import axios from 'axios';
import { getCorpsiteUrl } from '@/utils/environment';

interface CountryData {
  countryCode: string;
}
export const getCountryData = async (): Promise<CountryData> => {
  const path = `${getCorpsiteUrl()}/country`;
  const { data } = await axios.get(path);
  return data;
};
